import script from "./WeekendModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekendModal.vue?vue&type=script&setup=true&lang=js"

import "./WeekendModal.vue?vue&type=style&index=0&id=bffb4f78&scoped=true&lang=css"
/* custom blocks */
import block0 from "./WeekendModal.vue?vue&type=custom&index=0&blockType=spec&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bffb4f78"]])

export default __exports__